export const getCurrencyFromSpecs = selectedSpecs => {
  if (selectedSpecs.length === 0) return null;
  const projectCurrencyId = selectedSpecs[0].projectCurrencyId;
  const sameCurrency = selectedSpecs.every(
    selectedSpec => selectedSpec.projectCurrencyId === projectCurrencyId
  );
  return sameCurrency ? projectCurrencyId : null;
};
